import request from '@/utils/request'
import { method } from '@/utils/constant'

const { POST, GET } = method

export default {
  // 申请单个文件下载节点信息和token
  async getFileToken(params) {
    return request({
      method: GET,
      url: `/admin/file/applyDownLoadNode/${params.id}`,
    })
  },
}
